import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const apiPrefixInterceptor: HttpInterceptorFn = (req, next) => {
  if (/^https?:\/\//.test(req.url)) {
    return next(req);
  }

  return next(
    req.clone({
      url: `${environment.apiBaseUrl}${req.url.startsWith('/') ? req.url : `/${req.url}`}`,
    }),
  );
};
